import { PageLayout } from '@app/pages/layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'
import { Event } from '@app/components/blocks/event/Event'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { Empty } from '@app/components/blocks/empty/Empty'
import Column from '@app/components/layout/Column'
import { pages } from '@app/util/links'
import { StaticPageSeo } from '@app/components/core/seo/StaticPageSeo'

export const AgendaPage = () => {
  const t = useTranslations()
  const eventsPage = t.app.eventsPage
  const isMobile = useMediaQuery()
  const { tenant, loading } = useTenantContext()
  const events = tenant?.events ?? []

  return (
    <PageLayout gap={0}>
      <StaticPageSeo
        path={pages.events}
        pageTitle={eventsPage.title}
        description={eventsPage.description}
      />
      <Title.H1
        style={{
          textAlign: 'center',
          marginBottom: isMobile ? '2rem' : '4rem',
        }}
      >
        {t.app.blogPage.tabs.agenda}
      </Title.H1>

      <>
        {loading ? (
          <div>{t.app.blogPage.loading}</div>
        ) : events.length === 0 ? (
          <Empty title={t.app.blogPage.noContent} />
        ) : (
          <Column
            style={{ width: '100%', maxWidth: '40rem', alignSelf: 'center' }}
          >
            {events.map((item, index) => (
              <Event
                key={index}
                date={new Date(item.start).getDate()}
                month={new Date(item.start).toLocaleString('default', {
                  month: 'short',
                })}
                category={item.category || ''}
                title={item.title}
                intro={item.intro || ''}
                time={`${new Date(item.start).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })} - ${new Date(item.end).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })}`}
                location={item.location?.address || ''}
                to={pages?.event?.(item.slug)}
              />
            ))}
          </Column>
        )}
      </>
    </PageLayout>
  )
}
